import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CTAButtonProps {
  label: string;
  id?: string;
  className?: string;
}
export function CTAButton({
  label,
  id,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  return <a id={id} href={CHECKOUT_URL} onClick={handleClick} className={`group flex w-full items-center justify-center gap-2 rounded-xl bg-teal-500 px-5 py-4 text-center font-sans text-[15px] font-extrabold uppercase leading-tight tracking-wide text-ink-950 shadow-cta transition-[transform,background-color] duration-200 ease-out hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal-300 active:translate-y-[1px] sm:text-base ${className}`} data-id="element-24" data-mp="2tykyck93knt1">
      <span className="max-w-[16rem] sm:max-w-none" data-id="element-25" data-mp="38q3ld20djilw">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-26" data-mp="199obk6wc8roj" />
    </a>;
}